import React from "react";
import { motion } from "framer-motion";
import { Info, Music4 } from "lucide-react";
import { FORMATION_TYPES, INSTRUMENTS } from "@/lib/constants";

const Chip = ({ active, onClick, children, testId }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    className={`rounded-full border px-3.5 py-2 text-sm transition-colors ${
      active
        ? "border-[color:var(--brand-marsala)] bg-[color:var(--brand-marsala-soft)] text-[color:var(--brand-marsala)]"
        : "border-[color:var(--brand-border)] bg-white text-[color:var(--brand-graphite)] hover:bg-[color:var(--brand-paper)]"
    }`}
  >
    {children}
  </button>
);

export const FormationStep = ({ formation, onChange }) => {
  const f = formation || { type: "", instruments: [] };
  const setType = (t) => onChange({ ...f, type: f.type === t ? "" : t });
  const toggleInstr = (inst) => {
    const instruments = f.instruments.includes(inst)
      ? f.instruments.filter((x) => x !== inst)
      : [...f.instruments, inst];
    onChange({ ...f, instruments });
  };

  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }} className="mx-auto max-w-2xl">
      <h2 className="flex items-center gap-2 font-serif text-2xl font-semibold text-[color:var(--brand-graphite)] sm:text-3xl">
        <Music4 className="h-6 w-6 text-[color:var(--brand-marsala)]" /> Formação musical
      </h2>
      <p className="mt-2 text-sm text-[color:var(--brand-muted)]">
        Como vocês imaginam a formação que tocará na cerimônia?
      </p>
      <div className="mt-3 flex items-start gap-2 rounded-xl border border-[color:var(--brand-champagne)] bg-[color:var(--brand-champagne-soft)] p-3 text-sm text-[color:var(--brand-graphite)]">
        <Info className="mt-0.5 h-4 w-4 shrink-0 text-[color:var(--brand-marsala)]" />
        <span>
          <strong>* Sem certeza?</strong> Escolha "A definir com a LC" — nossa equipe orienta a melhor
          formação para o seu repertório e espaço.
        </span>
      </div>

      <div className="mt-6">
        <p className="mb-3 text-sm font-semibold text-[color:var(--brand-graphite)]">Formação</p>
        <div className="flex flex-wrap gap-2">
          {FORMATION_TYPES.map((t) => (
            <Chip key={t} active={f.type === t} onClick={() => setType(t)} testId={`formation-type-${t}`}>{t}</Chip>
          ))}
        </div>
      </div>

      <div className="mt-6">
        <p className="mb-1 text-sm font-semibold text-[color:var(--brand-graphite)]">Instrumentos desejados</p>
        <p className="mb-3 text-xs text-[color:var(--brand-muted)]">* Selecione quantos quiser — pode ajustar com a LC depois.</p>
        <div className="flex flex-wrap gap-2">
          {INSTRUMENTS.map((inst) => (
            <Chip key={inst} active={f.instruments.includes(inst)} onClick={() => toggleInstr(inst)} testId={`formation-instrument-${inst}`}>{inst}</Chip>
          ))}
        </div>
      </div>
    </motion.div>
  );
};
